// Currencies supported by Peru (PE) documents. Self-contained collection for the
// PE document form, decoupled from the shared currencies collection.
export const currencies = [
  { code: 'PEN', name: 'NUEVO SOL' },
  { code: 'USD', name: 'DOLAR USA' }
]
